/**
 * Catalyst.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EngagementRole } from './engagementRole';
import { EngagementTitleAllOf } from './engagementTitleAllOf';
import { CommunicationMode } from './communicationMode';
import { EngagementTeamMember } from './engagementTeamMember';
import { EngagementState } from './engagementState';
import { EngagementSyncState } from './engagementSyncState';
import { ClientVersionBaseReadModel } from './clientVersionBaseReadModel';
import { TeamMemberStatus } from './teamMemberStatus';
import { EngagementPurposeType } from './engagementPurposeType';


import { QueryEntityField } from 'src/standard/ts/types';

export const _EngagementTitleFields = [ 
    {
        field: "aptClientCurrentVersion",
        dataType: "number",
        dataFormat: "float",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "engagementId",
        dataType: "string",
        dataFormat: "uuid",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "startDate",
        dataType: "string",
        dataFormat: "date-time",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "endDate",
        dataType: "string",
        dataFormat: "date-time",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "clientName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "projectName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "entityName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "engagementName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "displayName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "clientId",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "projectId",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "memberFirm",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        isKey: true,
        field: "memberFirmId",
        dataType: "number",
        dataFormat: "int32",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "engagementType",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "industry",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "state",
        dataType: "EngagementState",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "base",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "language",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "isRTL",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "listedEntities",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "assuranceStandards",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "financialReportingStandards",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "groupEngagement",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "reportDate",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "reportTimeZone",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "housekeepingPeriod",
        dataType: "number",
        dataFormat: "int32",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "archivedDate",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "status",
        dataType: "TeamMemberStatus",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "engagementPurpose",
        dataType: "EngagementPurposeType",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "reportDateInString",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "mode",
        dataType: "CommunicationMode",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "signalREndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "syncApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "serverApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "reportApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "workspaceState",
        dataType: "EngagementSyncState",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "pausedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "lastOpened",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "releaseTitle",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "libraryVersion",
        dataType: "number",
        dataFormat: "decimal",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "rsaPublicKey",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "rsaPrivateKey",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "forbiddenFileTypes",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "maxFileSize",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "whoAmI",
        dataType: "EngagementTeamMember",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "reportFont",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "teamMemberEngagementRole",
        dataType: "EngagementRole",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "lockingJustification",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "lockedBy",
        dataType: "number",
        dataFormat: "int32",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "lockedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "isClassicEngagement",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "splitPanelSettings",
        dataType: "{ [key: string]: boolean; }",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "enableExportToExternalSystem",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "enableAutoSpellCheck",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "languageCulture",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "enableSendToGlobalPortal",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "isEngagementAvailable",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "isCrossBorderBlockListEngagement",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "lastModifiedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "copiedAt",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "archiveScheduleTime",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    {
        field: "hasEngagementSnapshot",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
] satisfies QueryEntityField<EngagementTitle>[];

export const EngagementTitleFieldLookup = { 
    "aptClientCurrentVersion": {
        field: "aptClientCurrentVersion",
        dataType: "number",
        dataFormat: "float",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "engagementId": {
        field: "engagementId",
        dataType: "string",
        dataFormat: "uuid",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "startDate": {
        field: "startDate",
        dataType: "string",
        dataFormat: "date-time",
        preferredFilterQueryOp: undefined,
    } as const,
    "endDate": {
        field: "endDate",
        dataType: "string",
        dataFormat: "date-time",
        preferredFilterQueryOp: undefined,
    } as const,
    "clientName": {
        field: "clientName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "projectName": {
        field: "projectName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "entityName": {
        field: "entityName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "engagementName": {
        field: "engagementName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "displayName": {
        field: "displayName",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "clientId": {
        field: "clientId",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "projectId": {
        field: "projectId",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "memberFirm": {
        field: "memberFirm",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "memberFirmId": {
        isKey: true,
        field: "memberFirmId",
        dataType: "number",
        dataFormat: "int32",
        preferredFilterQueryOp: undefined,
    } as const,
    "engagementType": {
        field: "engagementType",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "industry": {
        field: "industry",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "state": {
        field: "state",
        dataType: "EngagementState",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "base": {
        field: "base",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "language": {
        field: "language",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "isRTL": {
        field: "isRTL",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "listedEntities": {
        field: "listedEntities",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "assuranceStandards": {
        field: "assuranceStandards",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "financialReportingStandards": {
        field: "financialReportingStandards",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "groupEngagement": {
        field: "groupEngagement",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "reportDate": {
        field: "reportDate",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "reportTimeZone": {
        field: "reportTimeZone",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "housekeepingPeriod": {
        field: "housekeepingPeriod",
        dataType: "number",
        dataFormat: "int32",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "archivedDate": {
        field: "archivedDate",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "status": {
        field: "status",
        dataType: "TeamMemberStatus",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "engagementPurpose": {
        field: "engagementPurpose",
        dataType: "EngagementPurposeType",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "reportDateInString": {
        field: "reportDateInString",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "mode": {
        field: "mode",
        dataType: "CommunicationMode",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "signalREndpoint": {
        field: "signalREndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "syncApiEndpoint": {
        field: "syncApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "serverApiEndpoint": {
        field: "serverApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "reportApiEndpoint": {
        field: "reportApiEndpoint",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "workspaceState": {
        field: "workspaceState",
        dataType: "EngagementSyncState",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "pausedOn": {
        field: "pausedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "lastOpened": {
        field: "lastOpened",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "releaseTitle": {
        field: "releaseTitle",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "libraryVersion": {
        field: "libraryVersion",
        dataType: "number",
        dataFormat: "decimal",
        preferredFilterQueryOp: undefined,
    } as const,
    "rsaPublicKey": {
        field: "rsaPublicKey",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "rsaPrivateKey": {
        field: "rsaPrivateKey",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "forbiddenFileTypes": {
        field: "forbiddenFileTypes",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "maxFileSize": {
        field: "maxFileSize",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "whoAmI": {
        field: "whoAmI",
        dataType: "EngagementTeamMember",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "reportFont": {
        field: "reportFont",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "teamMemberEngagementRole": {
        field: "teamMemberEngagementRole",
        dataType: "EngagementRole",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "lockingJustification": {
        field: "lockingJustification",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "lockedBy": {
        field: "lockedBy",
        dataType: "number",
        dataFormat: "int32",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "lockedOn": {
        field: "lockedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "isClassicEngagement": {
        field: "isClassicEngagement",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "splitPanelSettings": {
        field: "splitPanelSettings",
        dataType: "{ [key: string]: boolean; }",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "enableExportToExternalSystem": {
        field: "enableExportToExternalSystem",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "enableAutoSpellCheck": {
        field: "enableAutoSpellCheck",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "languageCulture": {
        field: "languageCulture",
        dataType: "string",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "enableSendToGlobalPortal": {
        field: "enableSendToGlobalPortal",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "isEngagementAvailable": {
        field: "isEngagementAvailable",
        dataType: "boolean",
        dataFormat: "",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "isCrossBorderBlockListEngagement": {
        field: "isCrossBorderBlockListEngagement",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
    "lastModifiedOn": {
        field: "lastModifiedOn",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "copiedAt": {
        field: "copiedAt",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "archiveScheduleTime": {
        field: "archiveScheduleTime",
        dataType: "string",
        dataFormat: "date-time",
        nullable: true,
        preferredFilterQueryOp: undefined,
    } as const,
    "hasEngagementSnapshot": {
        field: "hasEngagementSnapshot",
        dataType: "boolean",
        dataFormat: "",
        preferredFilterQueryOp: undefined,
    } as const,
} satisfies Record<string, QueryEntityField<EngagementTitle>>;


export interface EngagementTitle { 
    aptClientCurrentVersion?: number;
    engagementId?: string;
    startDate: string;
    endDate: string;
    clientName?: string;
    projectName?: string;
    entityName?: string;
    engagementName?: string;
    displayName?: string;
    clientId?: string;
    projectId?: string;
    memberFirm?: string;
    memberFirmId: number;
    engagementType?: string;
    industry?: string;
    state: EngagementState;
    base?: string;
    language?: string;
    isRTL: boolean;
    listedEntities?: string;
    assuranceStandards?: string;
    financialReportingStandards?: string;
    groupEngagement?: string;
    reportDate?: string;
    reportTimeZone?: string;
    housekeepingPeriod?: number;
    archivedDate?: string;
    status: TeamMemberStatus;
    engagementPurpose: EngagementPurposeType;
    reportDateInString?: string;
    mode: CommunicationMode;
    signalREndpoint?: string;
    syncApiEndpoint?: string;
    serverApiEndpoint?: string;
    reportApiEndpoint?: string;
    workspaceState: EngagementSyncState;
    pausedOn?: string;
    lastOpened?: string;
    releaseTitle?: string;
    libraryVersion: number;
    rsaPublicKey?: string;
    rsaPrivateKey?: string;
    forbiddenFileTypes?: string;
    maxFileSize?: string;
    whoAmI?: EngagementTeamMember;
    reportFont?: string;
    teamMemberEngagementRole: EngagementRole;
    lockingJustification?: string;
    lockedBy?: number;
    lockedOn?: string;
    isClassicEngagement: boolean;
    splitPanelSettings?: { [key: string]: boolean; };
    enableExportToExternalSystem?: boolean;
    enableAutoSpellCheck: boolean;
    languageCulture?: string;
    enableSendToGlobalPortal?: boolean;
    isEngagementAvailable?: boolean;
    isCrossBorderBlockListEngagement: boolean;
    lastModifiedOn?: string;
    copiedAt?: string;
    archiveScheduleTime?: string;
    hasEngagementSnapshot: boolean;
}

